<template>
  <div v-if="isAssigned" class="d-flex align-center flex-wrap">
    <v-chip
      v-if="isAssignedToCurrentAccount"
      small
      class="me-2 mt-2"
      color="teal lighten-5"
      text-color="teal darken-2"
      >{{ $t('assignments.current_user_assignment') }}</v-chip
    >
    <template v-for="assignee in assignees">
      <span
        v-if="!isCurrentAccount(assignee)"
        class="me-2 mt-2"
        :key="assignee._id"
      >
        <ChipAvatar small :assignee="assignee" :account="assignee" />
      </span>
    </template>
  </div>
  <v-chip v-else small outlined class="me-2">{{
    $t('assignments.not_assigned_label')
  }}</v-chip>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import ChipAvatar from '@/components/ChipAvatar.vue'

import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'

export default {
  name: 'Assignees',

  mixins: [mixin, userMixin],

  props: {
    finding: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  components: {
    ChipAvatar,
  },

  methods: {
    isCurrentAccount(assignee) {
      return assignee?._id === this.account?._id
    },
  },

  computed: {
    ...mapGetters(['account']),

    isAssignedToCurrentAccount() {
      return this.isCurrentAccount(this.assignees?.[0])
    },

    assignees() {
      if (_.isEmpty(this.finding?.assignees)) return []

      const findingAssignees = [...(this.finding?.assignees ?? [])]

      const currentAccountIndex = findingAssignees.findIndex(
        assignee => assignee._id === this.account._id
      )

      const isCurrentAccountAnAssignee = currentAccountIndex !== -1
      if (!isCurrentAccountAnAssignee) return findingAssignees

      const currentAccount = findingAssignees[currentAccountIndex]
      findingAssignees.splice(currentAccountIndex, 1)

      return [currentAccount, ...findingAssignees]
    },

    isAssigned() {
      return !_.isEmpty(this.finding?.assignees)
    },
  },
}
</script>
